import React from 'react';
// React-table library requires to import css as well:
import ReactTable from 'react-table';
import 'react-table/react-table.css'; // eslint-disable-next-line

import PropTypes from 'prop-types';

const styles = {
  root: {
    // padding: "4px 4px 4px 4px",
  },
};

export default function CustomTable(props) {
  return (
    <div style={styles.root}>
      <ReactTable
        loading={props.loading}
        loadingText="Caricamento..."
        filterable={props.filterable}
        resizable={props.resizable}
        sortable={props.sortable}
        showPagination={props.showPagination}
        showPageSizeOptions={true}
        showPageJump={
          props.showPageJump === undefined ? true : props.showPageJump
        }
        defaultPageSize={
          props.defaultPageSize === null ? 10 : props.defaultPageSize
        }
        data={props.records}
        columns={props.columns}
        style={props.tableStyle}
        page={props.page}
        onPageChange={props.onPageChange}
        onFilteredChange={props.onFilteredChange}
        previousText="Precedente"
        nextText="Successivo"
        noDataText="Nessun record"
        pageText="Pagina"
        ofText="di"
        rowsText="righe"
        pageJumpText="Vai a pagina"
        rowsSelectorText="righe per pagina"
        defaultFilterMethod={(filter, row, column) => {
          const id = filter.pivotId || filter.id;
          return row[id] !== undefined
            ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase())
            : true;
        }}
        getTrProps={(state, rowInfo) => {
          if (!rowInfo) return {};

          return {
            key: rowInfo.original.id || rowInfo.index, // <-- assegna key stabile
          };
        }}
      />
    </div>
  );
}

CustomTable.propTypes = {
  columns: PropTypes.array.isRequired,
  records: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  filterable: PropTypes.bool.isRequired,
  resizable: PropTypes.bool.isRequired,
  sortable: PropTypes.bool.isRequired,
  defaultPageSize: PropTypes.number,
  showPagination: PropTypes.bool,
  showPageJump: PropTypes.bool,
  page: PropTypes.number,
  onPageChange: PropTypes.func,
  onFilteredChange: PropTypes.func,
};
